import React from 'react';
import {
    Card,
    FormLayout,
    Checkbox,
    Select,
    TextStyle
} from '@shopify/polaris';
import { useState, useEffect } from 'react';
import {
    TagTemplateFormElement
} from '../formElements/FormElements';
import { apiFetch as fetch } from '../../../../common/Helpers';

export function AutoTagProductsByVariantOptionSettings(props) {

    const [optionNames, setOptionNames] = useState([]);

    function onValueTemplateChange(value) {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.valueTemplate = value;
        props.onSettingsChange(newSettings);
    }

    function onOptionNameChange(value) {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.optionName = value;
        props.onSettingsChange(newSettings);
    }

    function onRemoveTagsIfQuantityIsZeroChange(value) {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.removeTagsIfQuantityIsZero = value;
        props.onSettingsChange(newSettings);
    }

    useEffect(() => {

        fetch(`api/products/optionNames`, {
            method: "GET",
        }).then(response => response.json())
            .then(data => setOptionNames(data));
    }, []);

    var hasPrefix = props.settings.valueTemplate.prefix != null && props.settings.valueTemplate.prefix.trim() !== ""

    return (
        <React.Fragment>
            <Card.Section>
                <FormLayout>
                    <Select
                        label="Option Name"
                        placeholder='--- Select Option ---'
                        options={optionNames}
                        onChange={onOptionNameChange}
                        value={props.settings.optionName}
                        error={props.settingsErrors["optionName"]}
                        helpText={
                            <span>
                                Select the option that will be used as value for the metafield.
                            </span>
                        }
                    />
                </FormLayout>
            </Card.Section>
            <Card.Section title="Tag Options">
                <FormLayout>
                    <TagTemplateFormElement
                        templateSettings={props.settings.valueTemplate}
                        templateSettingsErrors={props.settingsErrors["valueTemplate"] || {}}
                        onChange={onValueTemplateChange}
                    />
                </FormLayout>
            </Card.Section>
            <Card.Section title="Rule Options">
                <FormLayout>
                    <Checkbox
                        label="Remove variant tags for variants that are out of stock"
                        disabled={!hasPrefix}
                        checked={props.settings.removeTagsIfQuantityIsZero}
                        onChange={onRemoveTagsIfQuantityIsZeroChange}
                        helpText={
                            <span>
                                When checked, tags corresponding to the variant options will be deleted when the variants have zero quantity.
                            </span>
                        }
                    />
                    {!hasPrefix && <TextStyle variation="warning">This option requires prefix to be set.</TextStyle>}
                </FormLayout>
            </Card.Section>
        </React.Fragment>
    );
}